export default function EnquiryPage() {
    return (
      <div style={{ height: '100vh' }}>
        <iframe title="droplinked" src="./enquiry.html" width="100%" height="100%"></iframe>
      </div>
    )
  }
  